export default __webpack_public_path__ + "static/media/right-ear.3700c93a.svg";